import { RiCustomerService2Line } from '@remixicon/react';

import { Button } from '@spotify-internal/encore-web';
import { useSupportMessenger } from '@spotify/confidence-core-react';
import {
  type ToolGroupEntry,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

interface EscalatePayload {
  action: string;
  pre_filled_message: string;
  category?: string;
}

const parsePayload = (content: string): EscalatePayload | null => {
  try {
    const parsed = JSON.parse(content) as EscalatePayload;
    if (parsed.action === 'escalate_to_intercom') return parsed;
  } catch {
    return null;
  }
  return null;
};

const EscalateToSupportRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const { openChatWithMessage } = useSupportMessenger();

  if (!entry.result?.success) return null;

  const payload = parsePayload(entry.result.content);
  if (!payload) return null;

  return (
    <Button
      variant="tertiary"
      onClick={() => openChatWithMessage(payload.pre_filled_message)}
    >
      <RiCustomerService2Line size={16} />
      Connect to support
    </Button>
  );
};

export const EscalateToSupportToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'escalate-to-support',
    predicate: tool => tool.endsWith('escalate_to_support'),
    icon: RiCustomerService2Line,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <EscalateToSupportRenderer entry={entry} />,
  }),
);
